import * as React from "react";
import type { SVGProps } from "react";
const SvgFilmramme = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 119.031 118.969"
    {...props}
  >
    <path
      d="m272.939 276.249 4.393 4.392-4.829 4.816-4.393-4.393-41.919 41.921 4.393 4.392-4.815 4.811-4.393-4.392-2.394 2.39 62.812 62.8 2.392-2.386-4.726-4.726 4.824-4.805 4.72 4.719 41.928-41.92-4.723-4.713 4.821-4.827 4.718 4.717 2.262-2.251-62.814-62.8Zm8.015 101.475-4.829 4.814-6.733-6.732 4.823-4.806Zm-10.073-10.062-4.825 4.809-6.73-6.733 4.823-4.809Zm-10.074-10.074-4.825 4.813-6.728-6.727 4.82-4.818Zm-10.078-10.079-4.825 4.816-6.719-6.723 4.815-4.81Zm-10.075-10.064-4.807 4.806-6.744-6.723 4.827-4.814Zm87.035-6.459-4.811 4.823-6.738-6.738 4.817-4.817Zm-10.072-10.064-4.813 4.817-6.734-6.731 4.825-4.815Zm-10.066-10.07-4.82 4.818-6.731-6.733 4.826-4.817Zm-10.086-10.078-4.812 4.819-6.728-6.719 4.823-4.821ZM287.4 290.705l-4.826 4.823-6.727-6.73 4.818-4.824Z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-218.969 -274)"
    />
  </svg>
);
export default SvgFilmramme;
